import axios from '../../axios'
import type {
    AcknowledgeEditAssignmentResponse,
    EditAssignmentsApiEnvelope,
    PendingEditAssignmentsResponse,
} from './edit-assignments.types'

declare const route: (name: string, params?: Record<string, unknown> | string | number) => string

export const editAssignmentsApi = {
    pending: () =>
        axios.get<EditAssignmentsApiEnvelope<PendingEditAssignmentsResponse>>(
            route('api.edit-assignments.pending'),
            { suppressError: true } as object,
        ),
    acknowledge: (revisionId: number) =>
        axios.post<EditAssignmentsApiEnvelope<AcknowledgeEditAssignmentResponse>>(
            route('api.edit-assignments.acknowledge', revisionId),
            {},
            { suppressError: true } as object,
        ),
}

export const editAssignmentsQueryKeys = {
    all: ['edit-assignments'] as const,
    pending: () => [...editAssignmentsQueryKeys.all, 'pending'] as const,
}
